module.exports={author:"Ben Fama",date:"07/14/2021",publishDate:"07/14/2021",highlighted:!1,tags:"",badge:"",title:"Occult Symbolism of the Holy Grail Myth"};